import * as _m from '@/models';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
import { useFeatures } from '@/hooks/api/useFeatures';

export const Features = () => {
  const { data: features } = useFeatures();

  return (
    <>
      {features?.map((feature) => (
        <section key={feature.id} className="covers">
          <h2 className="section-title">{feature.name}</h2>
          <Swiper slidesPerView={'auto'} centeredSlides={false}>
            {feature.creators.map((c) => {
              const gtmClickValue = `creator_click:${c.id}`;
              return (
                <SwiperSlide key={`${c.id}`}>
                  <Link to={c.url} className="swiper-slide" target={'_blank'} data-gtm-click={gtmClickValue}>
                    <div className="wrapper" data-gtm-click={gtmClickValue}>
                      <img
                        src={c.profile_image_url}
                        className="cover"
                        loading={'lazy'}
                        data-gtm-click={gtmClickValue}
                      />
                      <img src={c.icon_url} className="icon" loading={'lazy'} data-gtm-click={gtmClickValue} />
                    </div>
                    <div className="content">
                      <div className="name">{c.name}</div>
                      <div className="count"></div>
                    </div>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </section>
      ))}
    </>
  );
};
